import vueCustomScrollbar from 'vue-custom-scrollbar'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import Arbo from './blocs/arbo.vue'

export default {
	data() {
    return {
    }
  },
	methods: {
		close_filter(){
			this.$store.commit('UI_SET_SHOW_FILTERS', {filters: false});
		},
		reset_filters(){
			this.$store.dispatch('resetDechets');
		}
	},
	computed:{
		filterIndex(){
			return this.$store.state.ui.show_filter_index;
		},
		myStyles(){
			return {
				transform: 'translateY('+this.height+')'
			}
		}
	},
	components: {
    vueCustomScrollbar,
    VueSlider,
    Arbo
  }
}